if (!customElements.get('td-pickup-availability')) {
  class TDPickupAvailability extends HTMLElement {
    constructor() {
      super();
  
      this.sectionId = this.dataset.sectionId;
      this.pickupElement = this.querySelector('.td-pickup-availability');
      this.userLat = null;
      this.userLng = null;
    }
  
    connectedCallback() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(this.userPosition.bind(this), this.locationError.bind(this));
        document.addEventListener('tdVariantChange', this.handleVariantChange.bind(this)); 
      } else {
        console.warn('Geolocation is not supported by this browser.');
      }
    }
  
    // Get user location then use it to generate pickup html
    userPosition(position) {
      this.userLat = position.coords.latitude;
      this.userLng = position.coords.longitude;
      this.generatePickupElement();
    }
  
    locationError(error) {
      switch(error.code) {
        case error.PERMISSION_DENIED:
          console.warn('User denied the request for Geolocation.');
          break;
        case error.POSITION_UNAVAILABLE:
          console.warn('Location information is unavailable.');
          break;
        case error.TIMEOUT:
          console.warn('The request to get user location timed out.');
          break;
        case error.UNKNOWN_ERROR:
          console.warn('An unknown location error occurred.');
          break;
      }
    }
  
    // Fetch new variant markup
    async handleVariantChange() {
      if (this.userLat && this.userLng) {
        try {
          let response = await fetch(`${window.location.pathname + window.location.search}&sections=${this.sectionId}`);
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          let productMarkup = await response.json();
          const newPickupElement = this.extractPickupElement(productMarkup[this.sectionId]);
          this.updatePickupElement(this.pickupElement, newPickupElement); 
        } catch (error) {
          console.error('Error fetching product markup:', error);
        }
      }
    }
  
    // Extract pickup element from new variant markup
    extractPickupElement(markup) {
        const tempContainer = document.createElement('div');
        tempContainer.innerHTML = markup;
        return tempContainer.querySelector('.td-pickup-availability'); 
    }
  
    // Update existing pickup data
    updatePickupElement(existingPickupElement, newPickupElement) {
      existingPickupElement.innerHTML = newPickupElement.innerHTML; 
      this.generatePickupElement();
    }
   
    // Generate pickup html based on user location
    generatePickupElement() {
      const locationTag = this.querySelector('.td-pickup-data') || null;
      let locationData = null;
      if (locationTag) {
        locationData = JSON.parse(locationTag.textContent);
      }
    
      if (locationData) {
        let closestDistance = Infinity;
        let closestLocation = null;
  
        locationData.forEach((location) => {
          const locationDistance = this.calculateDistance(this.userLat, this.userLng, location.lat, location.lng);
          if (locationDistance < closestDistance) {
            closestDistance = locationDistance;
            closestLocation = location;
          }
        });
        
        if (closestLocation) {
          this.pickupElement.innerHTML = ` 
            <div class="td-store-availability">
              <span class="td-store-availability__topline">
                <svg class="td-store-availability__icon" xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 344.93 573">
                  <path d="M172.47,0C77.22,0,0,77.21,0,172.47c0,19.92,3.42,39.04,9.63,56.85h-.06l.21.43c4.01,11.4,9.16,22.26,15.36,32.42l147.27,310.84,146.77-309.88c16.31-26.34,25.75-57.39,25.75-90.66C344.93,77.21,267.72,0,172.47,0ZM172.47,280.79c-59.83,0-108.33-48.5-108.33-108.33s48.5-108.33,108.33-108.33,108.33,48.5,108.33,108.33-48.5,108.33-108.33,108.33Z"/>
                </svg>
                In store availability at <a class="td-store-availability__location-name" href="${closestLocation.link}" target="_blank">${closestLocation.name}</a>
              </span>
              <a href="${closestLocation.link}" target="_blank">${closestLocation.address}</a> 
            </div>
          `;
        }
      }
    }
  
    // Haversine formula to calculate distance between two coordinates
    calculateDistance(lat1, lon1, lat2, lon2) {
      const R = 6371; // Radius of the earth in km
      const dLat = this.deg2rad(lat2 - lat1);
      const dLon = this.deg2rad(lon2 - lon1);
      const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(this.deg2rad(lat1)) *
        Math.cos(this.deg2rad(lat2)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      const distance = R * c; // Distance in km
      return distance;
    }
    deg2rad(deg) {
      return deg * (Math.PI / 180); 
    }
  }
  
  customElements.define('td-pickup-availability', TDPickupAvailability);
}
